import {
    OffersWonContext,
    OffersWonProvider,
    useOffersWon,
} from './offers-won.context';

export default { OffersWonContext, OffersWonProvider, useOffersWon };
